module.exports = __webpack_public_path__ + "static/img/brees-2020-slide-2.d702100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2020-slide-2.jpg
// module id = NRnq
// module chunks = 1